module.exports = __webpack_public_path__ + "static/DataBrannd_Monitor@2x-130c0a0d50f720d09cebd6722e0c08c0.png";